module.exports = __webpack_public_path__ + "img/liveBg.6acc58ac.png";